// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__V327f","address_wrapper":"styles_address_wrapper__Jjc2I","row":"styles_row__wtd4k"};